import React from 'react';
import { Select, Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import useAccionesAlarma from './useAccionesAlarma';
import styles from './AccionesAlarma.module.less';

import LayoutStep from '../../components/LayoutStep';
import SpecialCard from '../../components/SpecialCard';
import GenericWrapperAction from './components/GenericWrapperAction';

const { Option } = Select;

function AccionesAlarma(props) {

  const { t } = useTranslation();
  const { onPrevious, onSave, saveLoading } = props;
  const {
    actions,
    removeAction,
    addAction,
    onChangeType,
    missingTypes,
    urlActions,
    emailActions,
  } = useAccionesAlarma();

  const missingTypesValues = missingTypes.map(({ type }) => type);

  return (
    <LayoutStep onPrevious={onPrevious} onSave={onSave} saveLoading={saveLoading}>
      {actions.map((action, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <SpecialCard key={`action_${index}`} className={styles.action_wrapper}>
          <div className={styles.top_elements}>
            <Select
              placeholder="Selecciona un tipo de acción"
              className={styles.type_select}
              value={action.type}
              onChange={(value) => onChangeType(index, value)}
            >
              {/* <Option value="webhook" disabled={!missingTypesValues.includes('webhook')}>
                Webhook
              </Option> */}
              <Option value="email" disabled={!missingTypesValues.includes('email')}>
                {t('common.email')}
              </Option>
            </Select>
            <Button className={styles.btn_Trash} shape="circle" onClick={() => removeAction(index)}>
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </div>

          {action.type === 'webhook' && (
          <GenericWrapperAction
            inputType="url"
            action={action}
            actionTarget="urls"
            index={index}
            addItem={urlActions.addUrl}
            onChangeItem={urlActions.onChangeUrl}
            removeItem={urlActions.removeUrl}
          />
          )}

          {action.type === 'email' && (
          <GenericWrapperAction
            inputType="email"
            action={action}
            actionTarget="recipients"
            index={index}
            addItem={emailActions.addEmail}
            onChangeItem={emailActions.onChangeEmail}
            removeItem={emailActions.removeEmail}
          />
          )}
        </SpecialCard>
      ))}

      <Button
        disabled={actions && actions.length >= 1}
        type="dashed"
        className={styles.add_action_btn}
        onClick={addAction}
      >
        {t('views.default_alarms.commons.add_action')}
      </Button>
    </LayoutStep>
  );

}

AccionesAlarma.propTypes = {
  onPrevious: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saveLoading: PropTypes.bool.isRequired,
};

export default AccionesAlarma;
